module.exports = __webpack_public_path__ + "img/artist.55410005.png";